define((require) => {
    "use strict";

    var _                = require("underscore"),
        GeneralFunctions = require("editor/util/GeneralFunctions"),
        ParametersHelper = require("shared/ui/experience/action/ParametersHelper");

    var FIND_PARAMETERS_REGEX = new RegExp(ParametersHelper.PARAMETER_BEGIN + "(.*?)" + ParametersHelper.PARAMETER_END, "g");

    function removeSigns(text) {
        return text.slice(ParametersHelper.PARAMETER_BEGIN.length, -ParametersHelper.PARAMETER_END.length);
    }

    return {
        PARAMETER_CLASSNAME: "custom-js-parameter",
        FIND_PARAMETERS_REGEX: FIND_PARAMETERS_REGEX,

        /**
         * Takes a string, finds the parameters (as defined above with the
         * regex), and return them as an object with the parameters as keys,
         * and empty strings as their value.
         *
         * @param {String} text     - The string we are searching for parameters in.
         * @return {Object}         - Object with parameters as keys.
         */
        findParameters: function(text) {
            var parameters = _.chain(text.match(FIND_PARAMETERS_REGEX))
                .map(removeSigns)
                .unique()
                .value();

            return GeneralFunctions.arraysToObj(parameters, "");
        },

        /**
         * Takes the $textarea and surrounds the current selection (if any)
         * with our parameter signs, to turn the selection into a parameter.
         */
        addParametersToSelection: function($textarea) {
            var textarea = $textarea[0],
                begin,
                selection,
                end;

            if (_.isUndefined(textarea.selectionStart)) {
                return textarea.value;
            }

            begin       = textarea.value.substr(0, textarea.selectionStart);
            selection   = textarea.value.substr(textarea.selectionStart, textarea.selectionEnd - textarea.selectionStart);
            end         = textarea.value.substr(textarea.selectionEnd);

            return begin + ParametersHelper.PARAMETER_BEGIN + selection + ParametersHelper.PARAMETER_END + end;
        }

    };
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/integrations/customJs/editCustomJs/EditCustomJsViewHelpers.js